import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { EVENT } from '@/common/constants';
import { useEventAgent } from '@/common/hooks/useEventAgent';

import { NotificationWrapper } from '@/components/notification';

function Authorization() {
  const { t } = useTranslation();
  const { trackEvent } = useEventAgent();

  useEffect(() => {
    const sendPageViewEvent = async () => {
      await trackEvent(EVENT.NOTIFICATION_AUTHORIZATION_VIEW);
      await trackEvent(EVENT.SESSION_EXPIRED_VIEW);
    };

    sendPageViewEvent();
  }, []);

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-white'>
      <NotificationWrapper
        title={t('notificationErrorAuthorization.title')}
        help={t('notificationErrorAuthorization.help')}
        status="warning"
      />
    </div>
  );
}

export default Authorization;
